import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'next-i18next';

const IconCheck = () => (
  <svg
    width={12}
    height={12}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
)

const PricingCompareTable = ({ category }) => {
  const { t } = useTranslation("pricing");
  const features = t(category, { returnObjects: true });
  const theme = useTheme();

  const featureValueFor = (value) => {
    if (value === true) {
      return (
        <Box
          component={Avatar}
          bgcolor={theme.palette.secondary.main}
          width={20}
          height={20}
        >
          <IconCheck />
        </Box>
      );
    } else if (value === false) {
      return null;
    } else {
      return <Typography>{value}</Typography>;
    }
  };

  return (
    <>
      <Box marginBottom={4}>
        <Typography
          component="h2"
          fontWeight={700}
          variant={"h3"}
          align={"center"}
        >
          {features.title}
        </Typography>
      </Box>
      <Box>
        <TableContainer component={Paper} elevation={0}>
          <Table aria-label="caption table" sx={{ minWidth: 600 }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                {["essential", "professionnal", "premium"].map((item, i) => (
                  <TableCell align="center" key={`${i}-${item.icon}`}>
                    <Typography
                      sx={{ textTransform: "uppercase", fontWeight: "medium" }}
                    >
                      {t(`pricings.${i}.title`)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {features.list.map((feature, i) => (
                <TableRow key={`${category}-2-${i}`}>
                  <TableCell component="th" scope="row">
                    {feature.title}
                  </TableCell>
                  {["essential", "professionnal", "premium"].map((item) => (
                    <TableCell align="center" key={`feature-list-${item}`}>
                      <Box display={"flex"} justifyContent={"center"}>
                        {featureValueFor(feature[item])}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default PricingCompareTable;
